import styled from 'styled-components';

export const Root = styled.div`
  min-height: 100vh;
  max-width: 540px;
  margin: 0 auto;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  padding: 0 0 110px;
  position: relative;
  text-align: center;
  font-family: 'General Sans', sans-serif;
  font-style: normal;
  font-weight: 500;

  h1 {
    font-size: 42px;
    font-weight: 600;
    line-height: 54px;
    letter-spacing: 0.01em;
    text-align: center;
    color: var(--color-text-muted);
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
  }
`;
